"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fontanafredda": {
    "6d658fd5": [{
      "hkey": "70b01829",
      "slug": "vigonovo",
      "name": "Vigonovo",
      "primary": true,
      "skipSearch": false
    }],
    "romano": [{
      "hkey": "70b01829",
      "slug": "vigonovo",
      "name": "Vigonovo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fontanafredda"
    }],
    "552c634d": [{
      "hkey": "d3a74bdd",
      "slug": "centro-talmasson-villadolt",
      "name": "Centro-Talmasson-Villadolt",
      "primary": true,
      "skipSearch": false
    }],
    "talmassons": [{
      "hkey": "d3a74bdd",
      "slug": "centro-talmasson-villadolt",
      "name": "Centro-Talmasson-Villadolt",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "93aabea1": [{
      "hkey": "d3a74bdd",
      "slug": "centro-talmasson-villadolt",
      "name": "Centro-Talmasson-Villadolt",
      "primary": true,
      "skipSearch": false
    }],
    "villadolt": [{
      "hkey": "d3a74bdd",
      "slug": "centro-talmasson-villadolt",
      "name": "Centro-Talmasson-Villadolt",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "fontanafredda"
    }]
  }
};
exports["default"] = _default;